module.exports = __webpack_public_path__ + "static/img/coinHill.1f0148e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/coinHill.png
// module id = DE5B
// module chunks = 0